import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { throwError, of as observableOf, Subject, } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { UtilServiceService } from './utilService/util-service.service';

@Injectable({
  providedIn: 'root'
})
export class OathService {

 public refreshList$: EventEmitter<any>;
 /*******************************  Define endpoint *******************************/
private ENDPOINT_OAUTH_API = "/oauth2-clients";

 constructor(
      private http: HttpClient,
      private auth: AuthenticationService,
      private util: UtilServiceService
    ) { 
      this.refreshList$ = new EventEmitter();
      }


//************************************** Get All Maintenance Plans *************************************/
  public getAlloAuthList(search: any, parameters: any) {
      let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
     
      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url + this.ENDPOINT_OAUTH_API , { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
  }
  /************************************** Get Oauth By Id *************************************/
  getOAuthById(id: any) {
    return this.http.get(environment.base_url + this.ENDPOINT_OAUTH_API + `/${id}`,{ observe: "response"}).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
/************************************** Create Oauth  *************************************/
  createOAuth(data: any) {
    return this.http.post(environment.base_url + this.ENDPOINT_OAUTH_API+'/register', data,{ observe: "response"}).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
/************************************** Update Oauth  *************************************/
  updateOAuth(data: any, clientId: any) {
    return this.http.put(environment.base_url + this.ENDPOINT_OAUTH_API + `/${clientId}`, data,{ observe: "response"}).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  /************************************** Delete Oauth  *************************************/
  deleteOAuth(id: any) {
    return this.http.delete(environment.base_url + this.ENDPOINT_OAUTH_API + `/${id}`).pipe(
      map((resp: any) => {
        this.refreshList$.emit("OAuth Deleted");
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
 /************************************** Get Oauth By Id *************************************/
  getoAuthScope() {
    return this.http.get(environment.base_url + `/oauth2/api-scopes`).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
/************************************** Update Oauth Status *************************************/
  updateOAuthStatus(id: any, status: any) {
    const formData = new FormData();
    return this.http.put(environment.base_url + this.ENDPOINT_OAUTH_API + `/${id}/${status}`, formData, { observe: 'response'}).pipe(
      map((resp: any) => {
         this.refreshList$.emit("OAuth Status Update");
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

/************************************** Regenerate Secret Key *************************************/
  regenerateSecretKey(id: any) {
    const formData = new FormData();
    return this.http.post(environment.base_url + this.ENDPOINT_OAUTH_API + `/${id}/secret/regenerate`, formData, { observe: 'response'}).pipe(
      map((resp: any) => {
         this.refreshList$.emit("OAuth Secret Key Regenerated");
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  
}
